// src/com/auto_com_veh_info/AutoComVehInfoGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * AUTO_COM_VEH_INFO Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-10-22 16:13:13 using DbdbTap.
 ************************************************ */

const AUTO_COM_VEH_INFO_LIST_PART = gql`
fragment AutoComVehInfoListPart on AutoComVehInfo {
    dcCd
    comId
    vehTypeId
    vehTypeAlias
    vehRent
    vehPtCapa
    regDate
    regUser
    comName
    vehTypeName
    rentType
    dcName
    dcTypeCd
    regUserName
}
`;


export const LIST_AUTO_COM_VEH_INFO = gql`
${AUTO_COM_VEH_INFO_LIST_PART}
query ListAutoComVehInfo($dcCd:String!, $comId:String!) {
    autoComVehInfoList(dcCd:$dcCd, comId:$comId) {
        ...AutoComVehInfoListPart
    }
}
`;

export const GET_AUTO_COM_VEH_INFO = gql`
${AUTO_COM_VEH_INFO_LIST_PART}
query GetAutoComVehInfo($dcCd:String!, $comId:String!, $vehTypeId:String!) {
    autoComVehInfoItem(dcCd:$dcCd, comId:$comId, vehTypeId:$vehTypeId) {
        ...AutoComVehInfoListPart
    }
}
`;

export const ADD_AUTO_COM_VEH_INFO = gql`
mutation AddAutoComVehInfo($autoComVehInfo:InputAutoComVehInfoAdd!) {
	autoComVehInfoAdd(autoComVehInfo: $autoComVehInfo) {
		ok
		message
	}
}
`;

export const EDIT_AUTO_COM_VEH_INFO = gql`
mutation EditAutoComVehInfo($autoComVehInfo:InputAutoComVehInfoEdit!) {
	autoComVehInfoEdit(autoComVehInfo: $autoComVehInfo) {
		ok
		message
	}
}
`;

export const REMOVE_AUTO_COM_VEH_INFO = gql`
mutation RemoveAutoComVehInfo($autoComVehInfo:InputAutoComVehInfoRemove!) {
	autoComVehInfoRemove(autoComVehInfo: $autoComVehInfo) {
		ok
		message
	}
}
`;
